export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: 50,
    '& .dropzone-preview': {
      width: '100% !important',
    },
    '& .dropzone': {
      width: '100% !important',
    },
    '& > section + section': {
      marginTop: 50,
    },
  },
  whiteBlock: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    border: '1px solid #E6EAEE',
    borderRadius: 4,
    width: '100%',
    '& > *': {
      width: '50%',
    },
  },
  textWrapper: {
    marginLeft: 40,
  },
  largeText: {
    fontSize: 26,
    color: '#8A96A0',
  },
  smallText: {
    fontSize: 14,
    color: '#8A96A0',
  },

  contentWrapper: {
    display: 'flex',
    '& .ClientQuestionsView-existingPitchContainer': {
      display: 'none',
      justifyContent: 'space-around',
      alignItems: 'center',
      borderLeft: '1px solid hsl(210, 19%, 92%)',
    },
    '& .ClientQuestionsView-fileUploaderContainer': {
      width: '100%',
      '& > div': {
        width: '100%',
      },
    },
  },
  contentWrapperWithPitch: {
    '& .ClientQuestionsView-existingPitchContainer': {
      display: 'flex',
      width: '50%',
    },
    '& .ClientQuestionsView-fileUploaderContainer': {
      width: '50%',
    },
  },
  pitchUrlContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
    textDecoration: 'none !important',
    '& > span': {
      marginTop: '8px',
      color: 'hsl(214, 17%, 57%)',
      fontSize: '14px',
    },
  },
  hoverOpacity: {
    cursor: 'pointer',
    opacity: '1',
    transition: 'opacity .2s ease',
    '&:hover': {
      opacity: '.6',
    },
  },
  inactive: {
    pointerEvents: 'none',
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}
